'use client'
import React, { useState } from 'react';

import { GalleryPreviewImage } from './GalleryPreviewImage';
import { GalleryDialog } from './GalleryDialog';
import { MissingImage } from '@/stories/atoms/MissingImage/MissingImage';
import styles from './gallery.module.css';

export interface GalleryProps {
  images: string[],
  alt: string
}

export const Gallery = ({ images, alt }: GalleryProps)=> {
  const [open, setOpen] = useState(false)
  const [selectedIndex, setSelectedIndex] = useState(0)

  const selectIndex = (index: number) => {
    setOpen(true)
    setSelectedIndex(index)
  }

  if (images.length === 0) {
    return <MissingImage className={styles.missing} variant='large'/>
  }

  return (
    <div className={styles.container}>
      <div className={styles.wrapper}>
        {images.map((image, i) => i < 4 && (
          <GalleryPreviewImage
            key={i}
            image={image}
            alt={i === 0 ? alt : ''}
            onClick={() => selectIndex(i)}
            isFirst={ i === 0}
            isLast={i === 3 && images.length > 4}
            nbImages={images.length}/>
        ))}
      </div>
      <GalleryDialog open={open} images={images} onClose={() => setOpen(false)} selected={selectedIndex} setSelectedIndex={selectIndex}/>
    </div>
  )
};
